export default __webpack_public_path__ + "static/1_toggletips-position-a4ff185bbe3f01d588608c23f7377205.png";